import * as actions from 'actions';
import cx from 'classnames';
import * as Modules from 'components/modules';
import T from 'prop-types';
import React from 'react';
import {
  GoogleMap,
  Marker,
  withGoogleMap,
  withScriptjs,
} from 'react-google-maps';
import { connect } from 'react-redux';
import reactHtmlParser from 'react-html-parser';
import styles from './contacts.css';
import gmapStyles from './gmapStyles.json';
import * as s from './styled';

const MyMapComponent = withScriptjs(withGoogleMap(props => (
  <GoogleMap
    defaultOptions={{
        styles: gmapStyles,
        gestureHandling: 'cooperative',
      }}
    defaultZoom={15}
    defaultCenter={props.options.coordinates}
  >
    {props.isMarkerShown && <Marker position={props.options.coordinates} />}
  </GoogleMap>
)));

const Contacts = ({
  title,
  addresses,
  socials,
  reversed,
  map,
  colors,
  id,
  setPopup,
  popup,
}) => {
  const reversedNumber = +reversed;
  return (
    <s.Section id={id} reversed={reversedNumber}>
      <div className={cx(styles.imgWrapper)}>
        <MyMapComponent
          isMarkerShown
          options={{
            styles: map.styles,
            coordinates: {
              lat: +map.coordinates.lat,
              lng: +map.coordinates.lng,
            },
          }}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAJYuzowYE2slO5RG3DPS7W6eGjDAS5P-Y&v=3.exp&libraries=geometry,drawing,places"
          loadingElement={<div style={{ height: '100%', width: '100%' }} />}
          containerElement={<div style={{ height: '100%', width: '100%' }} />}
          mapElement={<div style={{ height: '100%', width: '100%' }} />}
        />
      </div>
      <div
        className={cx(styles.textWrapper)}
        style={{
          backgroundColor: colors.background,
        }}
      >
        <s.TextContainer reversed={reversedNumber}>
          <div className={styles.header}>
            <h1
              style={{
                color: colors.title,
              }}
              className={styles.title}
            >
              {title}
            </h1>
            <div className={styles.socials}>
              {socials.map(social => (
                <Modules.SocialLink key={social.title} {...social} />
              ))}
            </div>
          </div>
          {addresses.map(address => (
            <p
              style={{
                color: colors.description,
              }}
              className={styles.address}
              key={address}
            >
              {reactHtmlParser(address)}
            </p>
          ))}
        </s.TextContainer>
      </div>
      {popup === 'feedbackForm' && (
        <Modules.Popup>
          <Modules.FeedbackForm />
        </Modules.Popup>
      )}
    </s.Section>
  );
};

Contacts.propTypes = {
  id: T.string,
  title: T.string.isRequired,
  addresses: T.arrayOf(T.string.isRequired).isRequired,
  socials: T.arrayOf(T.shape({
    title: T.string.isRequired,
    href: T.string.isRequired,
  })).isRequired,
  reversed: T.oneOfType([T.string, T.number]).isRequired,
  map: T.shape({
    coordinates: T.shape({ lat: T.number, lng: T.number }),
  }).isRequired,
  colors: T.shape({
    title: T.string.isRequired,
    description: T.string.isRequired,
  }).isRequired,
};

const mapState = state => ({
  popup: state.popup,
});

const mapDispatch = dispatch => ({
  setPopup: popup => dispatch(actions.setPopup(popup)),
});

export default connect(mapState, mapDispatch)(Contacts);



// WEBPACK FOOTER //
// ./src/components/modules/Contacts/Contacts.js